import React from "react";
import ReactDOM from "react-dom";
// import tailwind utilities
import './index.css';
import App from './App';
import { ContextProvider } from "./contexts/ContextProvider";
//import { registerLicense } from "@syncfusion/ej2"

// Registering Syncfusion license key
//registerLicense('Ngo9BigBOggjHTQxAR8/V1NCaF5cXmZCeUx3RXxbf1x0ZFFMZFhbRXRPIiBoS35RckVkWXxfdnBRR2JbU0F3');

ReactDOM.render(
    // wrap the app with a contextProvider
    <ContextProvider>
        <App />
    </ContextProvider>, 
    document.getElementById('root')
);
